// Registre partage de l'activite de lecture (metronome/progression, backing
// track). Permet aux travaux de fond (sync cloud) d'attendre un moment calme
// au lieu de provoquer un pic CPU + re-render global pendant que ca joue.

const activeSources = new Set();

export const markPlaybackActive = (source) => {
  activeSources.add(source);
};

export const markPlaybackIdle = (source) => {
  activeSources.delete(source);
};

export const isPlaybackActive = () => activeSources.size > 0;

// Resout quand plus rien ne joue, ou apres maxWaitMs (on ne bloque jamais la
// sync indefiniment : un jam d'une heure ne doit pas empecher le push).
export const whenPlaybackIdle = ({ pollMs = 3000, maxWaitMs = 120000 } = {}) => {
  if (!isPlaybackActive()) return Promise.resolve();
  return new Promise((resolve) => {
    const start = Date.now();
    const check = () => {
      if (!isPlaybackActive() || Date.now() - start >= maxWaitMs) {
        resolve();
      } else {
        setTimeout(check, pollMs);
      }
    };
    setTimeout(check, pollMs);
  });
};
